import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@shared/context/ThemeContext";
import { DataProvider } from "@shared/context/DataContext";
// UserProvider is included in the public bundle because the shared
// ChatWidget + ReportModal flow consume UserContext (it gates the bug-report
// tab behind a logged-in user). It's a small provider that just hydrates from
// localStorage, so the cost is trivial vs. making every consumer defensive.
import UserProvider from "@shared/context/user";
import Home from "../components/Views/Home/Home";
import Contact from "../components/Views/PublicPages/Contact";
import Privacy from "../components/Views/PublicPages/Privacy";
import Terms from "../components/Views/PublicPages/Terms";
import Register from "../components/Views/PublicPages/Register";
import RequestVerificationEmail from "../components/Views/PublicPages/RequestVerificationEmail";
import VerifyEmail from "../components/Views/PublicPages/VerifyEmail";
import StripeCancelPage from "../components/Views/PublicPages/StripeCancel";
import StripeSuccessPage from "../components/Views/PublicPages/StripeSuccess";
import UseCaseRoute from "../components/Views/PublicPages/UseCaseRoute";
import ForgotPassword from "../components/Views/PublicPages/ForgotPassword";
import ResetPassword from "../components/Views/PublicPages/ResetPassword";
import CommunityDrip from "../components/Views/CommunityDrip/CommunityDrip";
import ShareDripPoC from "../components/Views/ShareDrip/ShareDripPoC";
import ChatWidget from "@shared/components/ChatWidget/ChatWidget";
import MaintenanceBanner from "@shared/components/MaintenanceBanner";
import ErrorBoundary from "@shared/components/ErrorBoundary";
import BlogIndex from "../components/Views/Blog/BlogIndex";
import BlogPost from "../components/Views/Blog/BlogPost";

export default function Router() {
  return (
    <ThemeProvider>
      <UserProvider>
      <DataProvider>
        <ErrorBoundary>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/drip" element={<CommunityDrip />} />
              <Route path="/drip/:curatorId" element={<CommunityDrip />} />
              <Route path="/share-drip/:token" element={<ShareDripPoC />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/use-cases/:slug" element={<UseCaseRoute />} />

              <Route path="/register" element={<Register />} />
              <Route
                path="/email-verify"
                element={<RequestVerificationEmail />}
              />
              <Route path="/verify-email" element={<VerifyEmail />} />

              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/terms-of-service" element={<Terms />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/stripe/default/success"
                element={<StripeSuccessPage />}
              />
              <Route
                path="/stripe/default/cancel"
                element={<StripeCancelPage />}
              />
              {/* /admin/* and /asset/* + /login are served by the standalone admin and app bundles via Apache rewrites. */}
            </Routes>
            <MaintenanceBanner />
            <ChatWidget />
          </BrowserRouter>
        </ErrorBoundary>
      </DataProvider>
      </UserProvider>
    </ThemeProvider>
  );
}
